// extracted by mini-css-extract-plugin
export var errorInput = "bd_df";
export var errorLabel = "bd_db";
export var inputContainer = "bd_dg";
export var inputNumber = "bd_dh";
export var inputPercentage = "bd_dj";
export var textInput = "bd_dk";
export var textInputDefault = "bd_dl";
export var textlabel = "bd_dc";